import styled from '@emotion/styled';

export const Button = (props:any) => {
    return (
        <StyledButton 
            {...props}>{props.children}
        </StyledButton>
    )
};

export const StyledButton = styled.button`
    background-color:"#11643C";
    color:"#fff";
    border:"none";
    outline:"none";
    padding:"15px 20px";
    border-radius:"5px";
`